export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'ID',
    },
    cell: {
      type: 'text',
      value: (e) => e.renterId,
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Renter',
    },
    cell: {
      type: 'slot',
      name: 'renter',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Turnover',
    },
    cell: {
      type: 'slot',
      name: 'turnover',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'ATMs',
    },
    cell: {
      type: 'slot',
      name: 'atms',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Status',
    },
    cell: {
      type: 'slot',
      name: 'status',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'actions',
    },
  },
];
